<template>
  <div id="app">
    <div>
      <Header
        @changeKey="setNavCheckedKey"
        v-bind:activeKey="activeKey"
        :newsDetailShow="newsDetailShow"
      ></Header>

      <!--主页-->
      <div v-if="activeKey === 0 && newsDetailShow === false">
        <HomePage/>
        <Reports @showDetails="navDetail"/>
      </div>

      <!--媒体列表页-->
      <!-- 社会责任页 new -->
      <div v-if="[1, 2].includes(activeKey) && newsDetailShow === false">
        <div class="m-newsWrapper">
          <div
            v-for="(news, index) of showLists"
            v-bind:key="index"
            @click="showDetail(news,index)"
          >
            <NewsItem v-bind:news="news"/>
          </div>
        </div>
        <div v-if="showLists.length !== this.newsList.length" class="m-news-loadMore">
          <p @click="loadMoreNews">加载更多</p>
        </div>
      </div>

      <div v-if="newsDetailShow === true">
        <NewsDetail
          @closedetail="closeDetailTab"
          :news="checkedNewsDetail"
          :prevDetail="prevDetail"
          :nextDetail="nextDetail"
          :index="detailIndex"
        />
        <div class="btn-wrapper">
          <p v-if="prevDetail !== undefined" class="prevBtn" @click="goPrev">
            <span>上一篇:</span>
            {{prevDetail.title}}
          </p>
          <p v-if="nextDetail !== undefined" class="nextBtn" @click="goNext">
            <span>下一篇:</span>
            {{nextDetail.title}}
          </p>
        </div>
      </div>

      <!--社会责任页 old-->
      <!-- <div v-if="activeKey === 2">
        <socialResponsibility/>
      </div> -->

      <Footer/>

      <p v-if="activeKey !== 2 && offsetTop >= 500" class="goTopBtn" @click="goTop">
        <span>回到</span>
        <span><br>顶部</span>
      </p>
    </div>
  </div>
</template>

<script>
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import Reports from './components/Reports';
import NewsItem from './components/NewsItem';
import newsList from 'assets/json/news-list';
import responsibilityList from 'assets/json/responsibility-list';
import NewsDetail from './components/NewsDetail';
import socialResponsibility from './components/socialResponsibility';

const designWidth = 750;
const pcUrl = 'http://www.qutoutiao.net';
export default {
    name: 'MIndex',
    components: {
        Header,
        Footer,
        HomePage,
        Reports,
        NewsItem,
        NewsDetail,
        socialResponsibility,
    },
    data() {
        return {
            offsetTop: 0,
            activeKey: 0, //header选中id
            newsList: [], //全部新闻列表数组
            showLists: [], //显示新闻列表数组
            newsDetailShow: false, //新闻详情显示开关状态，默认关闭
            checkedNewsDetail: {}, //新闻展示详情
            prevDetail: {}, //上一篇
            nextDetail: {}, //下一篇
            detailIndex: 0, //文章序号
        };
    },
    methods: {
        goTop() {
            document.documentElement.scrollTop = document.body.scrollTop = 0;
        },
        handleScroll() {
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            this.offsetTop = scrollTop;
        },
        setNavCheckedKey(key) {
            this.activeKey = key;
            this.newsDetailShow = false;
            this.getNewsDataLocal();
            this.goTop();
        },
        getNewsDataLocal() {
            this.newsList = (this.activeKey === 2 ? responsibilityList.newsList : newsList.newsList).sort((a, b) => {
                const date2Num = date => {
                    return parseInt(date.split('-').join(''));
                };
                if (a.order === b.order) {
                    return date2Num(b.date) - date2Num(a.date);
                }
                return b.order - a.order;
            });
            this.showLists = this.newsList.slice(0, 5);
        },
        loadMoreNews() {
            let num = this.showLists.length + 2;
            this.showLists = this.newsList.slice(0, num);
        },
        showDetail(news, index) {
            this.checkedNewsDetail = Object.assign({}, news);
            this.detailIndex = index;
            this.prevDetail =
                this.newsList[index - 1] === undefined
                    ? undefined
                    : this.newsList[index - 1];
            this.nextDetail =
                this.newsList[index + 1] === undefined
                    ? undefined
                    : this.newsList[index + 1];
            this.newsDetailShow = true;
            this.goTop();
        },
        closeDetailTab() {
            this.newsDetailShow = false;
        },
        goPrev() {
            this.newsDetailShow = false;
            this.showDetail(
                this.newsList[this.detailIndex - 1],
                this.detailIndex - 1,
            );
            this.goTop();
        },
        goNext() {
            this.newsDetailShow = false;
            this.showDetail(
                this.newsList[this.detailIndex + 1],
                this.detailIndex + 1,
            );
            this.goTop();
        },
        navDetail(news) {
            let num = 0;
            let data = this.newsList.filter((e, i) => {
                if (e.id === news.id) {
                    num = i;
                }
                return e.id === news.id;
            })[0];
            this.showDetail(data, num);
        },
    },
    mounted() {
        //判断环境跳转m站或pc端
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
            //s
        } else {
            window.location.href = pcUrl;
        }
        if (deviceWidth > 980) {
            window.location.href = pcUrl;
        }
        let deviceWidth = document.documentElement.clientWidth;
        document.documentElement.style.fontSize =
            (deviceWidth / designWidth) * 55 + 'px';
        window.addEventListener('scroll', this.handleScroll);
        this.getNewsDataLocal();
    },
};
</script>

<style lang="less">
@import '../../assets/style/_variables.less';
@import '../../assets/style/reset.less';
body {
    transition: all 0.3s;
}
.goTopBtn {
    height: 30px;
    width: 30px;
    z-index: 30;
    text-align: center;
    background: #a4aab3;
    padding-top: 2px;
    position: fixed;
    bottom: 169px;
    right: 27px;
    font-family: PingFangSC-Medium;
    font-size: 0.321rem;
    color: #ffffff;
}
.m-newsWrapper {
    background: #f9fafb;
    padding: 2.7rem 0.589rem 0;
}
.m-news-loadMore {
    text-align: center;
    padding: 0.3rem 0 1rem 0;
    p {
        width: 2.96rem;
        height: 0.928rem;
        border: 1px solid #35af5d;
        border-radius: 2px;
        color: #35af5d;
        text-align: center;
        line-height: 0.928rem;
        display: inline-block;
    }
}
.btn-wrapper {
    padding: 0.6rem 0.607rem 0;
    border-top: 1px solid #d8d8d8;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: PingFangSC-Regular;
    font-size: 0.428rem;
    color: #9b9b9b;
    p {
        padding-bottom: 8px;
        color: #4a4a4a;
    }
    span {
        color: #9b9b9b;
    }
}
</style>
